import { render, staticRenderFns } from "./GlobalWatermark.vue?vue&type=template&id=2089fc60&scoped=true"
import script from "./GlobalWatermark.vue?vue&type=script&lang=js"
export * from "./GlobalWatermark.vue?vue&type=script&lang=js"
import style0 from "./GlobalWatermark.vue?vue&type=style&index=0&id=2089fc60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089fc60",
  null
  
)

export default component.exports